module.exports = __webpack_public_path__ + "static/media/SPRAY5.ef67be58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY5.png
// module id = 287
// module chunks = 0